<template>
  <ElInput
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    placeholder="请输入区域名称"
    size="small"
  />
</template>

<script setup>
import { ElInput } from 'element-plus';

defineProps({
  modelValue: { type: String, default: '' },
});
defineEmits(['update:modelValue']);
</script>
